<template>
  <div class="enlistdetail">
    <div class="title">
      <div>
        <input placeholder="开始日期" type="date" @input="choosestart1" v-model="start_time1"/> —
        <input placeholder="结束日期" type="date" @input="chooseend1" v-model="end_time1"/>
      </div>
    </div>
    <div class="group">
      <div class="head special" v-if="!none">
        <div class="first">排名</div>
        <div class="second">大使</div>
        <div class="third">机器销售额</div>
        <div class="third">胶囊销售额</div>
        <div class="third">合计</div>
      </div>
      <div class="head" v-for="(item,index) in lists">
        <div class="first">{{item.rank_no}}</div>
        <div class="second" @click="detail(item.school_qrcode_id)">{{item.name}}</div>
        <div class="third">{{item.machine_amount}}</div>
        <div class="third">{{item.capsule_amount}}</div>
        <div class="third">{{item.machine_amount+item.capsule_amount}}</div>
      </div>
      <div class="head special" v-if="!none">
        <div class="first"></div>
        <div class="second">汇总：</div>
        <div class="third">{{total1}}</div>
        <div class="third">{{total2}}</div>
        <div class="third">{{total3}}</div>
      </div>
      <div class="none" v-if="none">暂无数据</div>
    </div>


    <div class="foot special">
      <div class="tabs" @click="link(1)">
        <div class="tab tab1"></div>
        <div class="txt">首页</div>
      </div>
      <div class="tabs" @click="link(2)">
        <div class="tab tab2"></div>
        <div class="txt">业绩查询</div>
      </div>
    </div>
  </div>
</template>

<script>
  let role
  let school_id
  let link='http://ap.bjcreate.net/school/'
  let openid
  let start_time
  let end_time
  let qrcode_id
  export default {
    name: "saleDetail",
    data () {
      return {
        value1:'',
        start_time1:'',
        end_time1:'',
        lists:[

        ],
        none:false,
        total1:0,
        total2:0,
        total3:0
      }
    },
    mounted() {
      role=this.$route.query.role
      school_id=this.$route.query.school_id
      openid=this.$route.query.openid
      start_time=this.$route.query.start_time
      end_time=this.$route.query.end_time
      qrcode_id=this.$route.query.qrcode_id
      this.start_time1=start_time
      this.end_time1= end_time
      this.getsaledetail()
    },
    created() {

    },
    methods:{
      getsaledetail(){
        this.$axios.post(link+'api/school/getadminorderamountrankdetails',
          {
            openid:openid,
            school_id:school_id,
            start_time:start_time,
            end_time:end_time,
            qrcode_id:qrcode_id
          }
        ).then(res=>{
          console.log(res.data)
          this.lists=res.data.ResultData
          if(res.data.ResultData&&res.data.ResultData.length>0){
            res.data.ResultData.forEach(value=>{
               this.total1+=value.machine_amount
               this.total2+=value.capsule_amount
               this.total3+=(value.machine_amount+value.machine_amount)
            })
            this.none=false
          }else{
            this.none=true
          }

        }).catch(error=>{
          console.log(error)
        })
      },
      detail(item){
        console.log(item)
        this.$router.push({
          path:'detail?openid='+openid+'&qrcode_id='+item+'&start_time='+this.start_time1+'&end_time='+this.end_time1+'&role='+role
        })
      },
      link(e){
        console.log(e)
        if(e==1){
          this.$router.push({
            path:'/?o='+openid+'&r='+role
          })
        }else if(e==2){
          this.$router.push({
            path:'search?openid='+openid+'&role='+role
          })
        }
      },
      choosestart1(e){
        this.start_time1=e.target.value
        start_time=e.target.value
        this.getsaledetail(school_id,this.start_time1,this.end_time1)
      },
      chooseend1(e){
        console.log(e.target.value)

        end_time=e.target.value
        this.end_time1=e.target.value
        this.getsaledetail(school_id,this.start_time1,this.end_time1)
      },
    }
  }
</script>

<style scoped>
  .title{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    line-height:0.8rem;
    font-size:0.32rem;
    background-color: #fff;
    max-width:6.8rem;
    margin:0 auto 0;
    padding:0.2rem 0;
  }
  .title input{
    height:1rem;
    line-height:1rem;
    border:1px solid #ddd;
    background-color:#fff;
    padding-left:0.1rem;
    font-size:0.3rem;
    -webkit-appearance: none;
  }
  .none{
    text-align: center;
    color:#666;
    font-size:0.3rem;
    margin-top:1rem;
  }
  body{
    background-color:#fff;
  }
  .enlistdetail{
    padding:0.4rem 0.2rem 1.6rem 0.4rem;
  }
  .group{
    overflow-y: hidden;
  }
  .el-date-editor--daterange.el-input__inner{
    width:280px;
    margin-bottom:0.3rem;
  }
  .head{
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: flex-start;*/
    font-size:0.24rem;
    line-height:0.72rem;
    border-bottom:1px solid #eaeaea;
    color:#555555;
    width: 9rem;
    overflow: auto;
  }
  .head.special{
    color:#000;
  }
  .head>div{
    display: inline-block;
  }
  .head>div.second{
    text-decoration: underline;
  }
  .head.special>div.second{
    text-decoration: none;
  }
  .first{
    width:1rem;
  }
  .second{
    width:2.6rem;
  }
  .five{
    width:3.6rem;
  }
  .third{
    width:1.6rem;
  }
  .fourth{

  }

  .foot{
    position: fixed;
    width:100%;
    height:1.3rem;
    background-color:#fff;
    left:0;
    bottom:0;
    font-size:0.22rem;
    display: flex;
    align-items:flex-start;
    justify-content: space-between;
    padding-top:0.2rem;
    color:#A8A8A8;
    box-shadow:2px 0px 5px rgba(0,0,0,0.2);
  }
  .foot.special{
    justify-content: center;
  }
  .foot>.tabs{
    width:2.3rem;
    text-align: center;
  }
  .foot.special>.tabs{
    width:3.3rem;
    text-align: center;
  }
  .tab1{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon9.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab1{
    background: url(../assets/icon9-on.png) no-repeat center top;
    background-size: 100%;
  }
  .foot>.on .txt{
    color:#FF9831;
  }

  .tab2{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon10.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab2 {
    background: url(../assets/icon10-on.png) no-repeat center top;
    background-size: 100%;
  }
  .tab3{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon16.jpg) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab3{
    background: url(../assets/icon16-on.jpg) no-repeat center top;
    background-size: 100%;
  }
  a{
    text-decoration:none;
    outline: none;	/* 去除旧版浏览器的点击后的外虚线框 */
    color: #000;
  }
  .txt{
    color:#000;
  }
</style>






// WEBPACK FOOTER //
// src/components/saleDetail.vue